import React from 'react';

import Dialog from '../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../reusables/Dialog/extras/caption';
import DialogExtraImage from '../../../../../reusables/Dialog/extras/image';

import iconWarning from '../../../../../../assets/illustrations/warning.svg';

interface IProps {
  handlerClose: () => void;
  show: boolean;
}

const ModalConfirm = ({ handlerClose, show }: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    textButtonA="Entendido"
    zIndex={1000}
    handlerButtonA={() => handlerClose()}
  >
    <DialogExtraImage src={iconWarning} alt="iconWarning" />
    <DialogExtraCaption
      subtitle="Te recomendamos cambiar de turno o anular tu reserva anterior."
      title="Tienes una reserva programada en este horario"
    />
  </Dialog>
);

export default ModalConfirm;
